import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const servicesQuestionApi = createApi({
  reducerPath: "servicesQuestionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "services/category-requests/",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getQuestion: builder.query({
      query: (query = {}) => {
        const { questionId = "" } = query;
        return {
          url: `${questionId}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {useGetQuestionQuery} = servicesQuestionApi